import { Box, Typography, Button } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import SearchOffIcon from '@mui/icons-material/SearchOff';

/**
 * @param {'default' | 'initial' | 'filtered'} variant
 *   initial — rien n’existe encore ; filtered — filtres sans résultat
 */
export default function EmptyState({
  title = 'Rien ici pour le moment',
  description = '',
  icon: Icon,
  action = null,
  variant = 'default',
}) {
  const ResolvedIcon = Icon ?? (variant === 'filtered' ? SearchOffIcon : InboxIcon);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        py: 'var(--space-3xl, 48px)',
        px: 'var(--space-lg, 16px)',
        textAlign: 'left',
        bgcolor: 'background.paper',
        borderRadius: 'var(--radius-lg, 12px)',
        boxShadow: 'var(--shadow-surface, none)',
        maxWidth: 560,
        mx: 'auto',
      }}
    >
      <ResolvedIcon sx={{ fontSize: 56, color: 'text.disabled', mb: 1, alignSelf: 'center' }} />
      <Typography variant="h6" component="h2" sx={{ alignSelf: 'stretch' }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, alignSelf: 'stretch' }}>
          {description}
        </Typography>
      )}
      {action && (
        <Button
          variant="contained"
          sx={{ mt: 3, minHeight: 44, alignSelf: 'stretch', maxWidth: 360 }}
          onClick={action.onClick}
          startIcon={action.icon}
        >
          {action.label}
        </Button>
      )}
    </Box>
  );
}
